import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import About from '../components/About';
import Showcase from '../components/Showcase';
import Footer from '../components/Footer';
import Manifesto from '../components/Manifesto';
import SEO from '../components/SEO';
import Intro from '../components/Intro';
import { handleNetlifyIdentity, Socials } from '../components/Tools';

const IndexPage = ({ location, data }) => {
  const [isIntroPlaying, setIntroPlaying] = useState(true);
  const { markdownRemark } = data;
  const { frontmatter } = markdownRemark;

  const handleIntroPlaying = () => {
    setIntroPlaying(!isIntroPlaying);
  };

  useEffect(() => {
    handleNetlifyIdentity();
  }, []);

  return (
    <Layout
      lang={frontmatter.lang}
      socials={[
        {
          icon: Socials.LinkedIn,
          link: 'https://www.linkedin.com/company/78052452/',
        },
        {
          icon: Socials.Insta,
          link: 'https://www.instagram.com/presentpresent.ca/',
        },
      ]}
      isReady={!isIntroPlaying}
    >
      <SEO
        location={location}
        title={frontmatter.seo.title}
        description={frontmatter.seo.description}
        image={frontmatter.seo.image}
      />

      {isIntroPlaying ? (
        <Intro handleIntroPlaying={handleIntroPlaying} />
      ) : null}

      <Hero
        video={frontmatter.hero.video}
        title={frontmatter.hero.title}
        text={frontmatter.hero.text}
        button={frontmatter.hero.button}
      />
      <About list={frontmatter.about.list} />
      <Showcase
        title={frontmatter.showcase.title}
        text={frontmatter.showcase.text}
      />
      <Manifesto
        title={frontmatter.manifesto.title}
        text={frontmatter.manifesto.text}
      />
      <Footer
        title={frontmatter.footer.title}
        intro={frontmatter.footer.intro}
        email={frontmatter.footer.email}
        text={frontmatter.footer.text}
      />
    </Layout>
  );
};

export const query = graphql`
  query indexPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        lang
        seo {
          title
          description
          image {
            publicURL
            relativePath
          }
        }
        hero {
          video
          title
          text
        }
        about {
          list {
            title
            text
          }
        }
        showcase {
          title
          text
        }
        manifesto {
          title
          text
        }
        footer {
          title
          intro
          email
          text
        }
      }
    }
  }
`;

export default IndexPage;
